// EmailUpdateForm.jsx
import React, { useState } from 'react';
import { Button, TextField, Flex, Text } from '@radix-ui/themes';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import api from '../../api';
import { updateUserDetails } from '../../redux/slices/userSlice';
import { toast } from 'react-toastify';

const EmailUpdateForm = ({ setShowEmailDialog }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email('Invalid email')
                .required('Email is required'),
        }),
        onSubmit: async (values) => {
            try {
                setLoading(true);
                const response = await api.put(`/user/profile`, { email: values.email });
                const data = response.data;

                if (data.errors) {
                    formik.setErrors(data.errors);
                } else {
                    dispatch(updateUserDetails(data.userDetails));
                    localStorage.setItem('userDetails', JSON.stringify(data.userDetails));
                    toast.success('Email updated successfully, click on button again to proceed', {
                        position: "bottom-right"
                    });
                    setShowEmailDialog(false);
                }
            } catch (err) {
                if (err.response?.data?.errors) {
                    formik.setErrors(err.response.data.errors);
                }
                toast.error('Failed to update email', {
                    position: "bottom-right"
                });
            } finally {
                setLoading(false);
            }
        }
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <Flex direction="column" gap="3">
                <TextField.Root
                    size="3"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter your email"
                />
                {formik.touched.email && formik.errors.email && (
                    <Text color="red" size="2">{formik.errors.email}</Text>
                )}

                <Flex justify="end" gap="3" mt="4">
                    <Button
                        variant="soft"
                        onClick={() => setShowEmailDialog(false)}
                        disabled={loading}
                        className='cursor-pointer'
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="solid"
                        color="green"
                        disabled={loading}
                        className='cursor-pointer'
                    >
                        {loading ? 'Saving...' : 'Save'}
                    </Button>
                </Flex>
            </Flex>
        </form>
    );
};

export default EmailUpdateForm;